import { Directive, Input } from '@angular/core';
import { Subject, fromEvent } from 'rxjs';
import { debounceTime, delay, filter, takeUntil } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/a11y";
import * as i2 from "@mhe/ngx-shared/input";
export class AutocompleteTriggerDirective {
    constructor(focus, hostInput) {
        this.focus = focus;
        this.hostInput = hostInput;
        this.destroy = new Subject();
    }
    ngOnInit() {
        this.monitorSelectionChange();
        this.monitorInputChange();
        this.monitorFocus();
    }
    ngOnDestroy() {
        this.focus.stopMonitoring(this.hostInput.inputEl);
        this.destroy.next();
        this.destroy.complete();
    }
    monitorSelectionChange() {
        this.autocomplete.selectionChange.pipe(takeUntil(this.destroy)).subscribe(({ viewValue }) => {
            this.hostInput.writeValue(viewValue);
        });
    }
    monitorFocus() {
        const { inputEl } = this.hostInput;
        const monitor$ = this.focus.monitor(inputEl);
        const focus$ = monitor$.pipe(filter((e) => e !== null));
        const blur$ = monitor$.pipe(filter((e) => e === null));
        focus$.subscribe(() => this.autocomplete.openMenu(inputEl));
        blur$.pipe(delay(100)).subscribe(() => this.autocomplete.hideAutocomplete());
    }
    monitorInputChange() {
        const { inputEl } = this.hostInput;
        const { overlayRef } = this.autocomplete;
        const change$ = fromEvent(inputEl.nativeElement, 'input');
        change$.pipe(debounceTime(300), takeUntil(this.destroy)).subscribe(() => {
            if (!overlayRef) {
                this.autocomplete.openMenu(inputEl);
            }
        });
    }
}
AutocompleteTriggerDirective.ɵfac = function AutocompleteTriggerDirective_Factory(t) { return new (t || AutocompleteTriggerDirective)(i0.ɵɵdirectiveInject(i1.FocusMonitor), i0.ɵɵdirectiveInject(i2.InputComponent)); };
AutocompleteTriggerDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: AutocompleteTriggerDirective, selectors: [["mhe-input", "autocomplete", ""]], inputs: { autocomplete: "autocomplete" }, exportAs: ["autocompleteTrigger"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AutocompleteTriggerDirective, [{
        type: Directive,
        args: [{
                selector: 'mhe-input[autocomplete]',
                exportAs: 'autocompleteTrigger',
            }]
    }], function () { return [{ type: i1.FocusMonitor }, { type: i2.InputComponent }]; }, { autocomplete: [{
            type: Input
        }] }); })();
